import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-payments-reports-nb-unfinished-transactions-card',
  templateUrl: './payments-reports-nb-unfinished-transactions-card.component.html',
  styleUrls: ['./payments-reports-nb-unfinished-transactions-card.component.scss']
})
export class PaymentsReportsNbUnfinishedTransactionsCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
